import { SvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

/**
 * Checked-state checkbox icon for the dashed variant.
 *
 * Keeps the same 24x24 icon footprint as MDI's checkbox icons so it aligns in
 * table/list legend rows, while the visible glyph remains a horizontal dashed
 * line to match threshold series in the chart.
 */
export const CheckboxDashedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24" fill="none">
        <path d="M4 12H20" stroke="currentColor" strokeWidth="3" strokeLinecap="butt" strokeDasharray="4 2" />
      </svg>
    </SvgIcon>
  );
};
